import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'
import { PlaceDetailsApiResult, PlaceDetailsResult } from '@/types/autoComplete'
import { autoCompleteSessionToken, clearAutoCompleteSessionToken } from '@/utils/autoComplete'
import { brand } from '@/utils/brand'
import { getLambdaEndpoint } from '@/utils/urlHelpers'

const GET_PLACEDETAILS_QUERY = gql`
  query getPlaceDetails($input: PlaceDetailsInput!) {
    getPlaceDetails(input: $input) {
      city
      country
      countryCode
      formattedAddress
      lat
      lng
      name
      placeId
      state
      street
      subTypes
      subpremise
      types
      zip
    }
  }
`

export const usePlaceDetailsApi = (placeId: string): UseQueryResult<PlaceDetailsResult, Error> => {
  const client = useGraphQLClient(getLambdaEndpoint(brand.key))
  const sessionToken = autoCompleteSessionToken()

  const fetchPlaceDetails = async (): Promise<PlaceDetailsResult> => {
    const data = await client.request<PlaceDetailsApiResult>(GET_PLACEDETAILS_QUERY, {
      input: { placeId, sessiontoken: sessionToken },
    })
    // google requires that the place details session token be cleared after place details call
    clearAutoCompleteSessionToken()
    return data.getPlaceDetails
  }

  return useQuery<PlaceDetailsResult>({
    queryKey: ['place-details', brand.key, placeId],
    enabled: !!placeId,
    queryFn: fetchPlaceDetails,
  })
}
